"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBLANG_NEUTRAL = 0x00;
exports.SUBLANG_DEFAULT = 0x01;
exports.SORT_DEFAULT = 0x00;
//# sourceMappingURL=lcid.js.map